import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

function AgencyOfficials() {
  const { id: renew_id, plantName} = useParams(); // ✅ get renew_id from URL
  const [officials, setOfficials] = useState([]);

  // ✅ Fetch officials for specific renewable agency
  useEffect(() => {
    const fetchOfficials = async () => {
      try {
        const res = await axios.get(
          `https://backend-zkgn.onrender.com/api/renewable-agency-officials/${renew_id}`
        );
        setOfficials(res.data);
      } catch (error) {
        console.error("Error fetching officials:", error.message);
      }
    };

    fetchOfficials();
  }, [renew_id]);

  // ✅ Delete handler
  const handleDelete = async (renew_official_id) => {
    if (window.confirm("Are you sure you want to delete this official?")) {
      try {
        await axios.delete(
          `https://backend-zkgn.onrender.com/api/renewable-agency-officials/delete/${renew_official_id}`
        );
        setOfficials((prev) =>
          prev.filter((off) => off.renew_official_id !== renew_official_id)
        );
      } catch (err) {
        console.error("Delete failed:", err.message);
      }
    }
  };

  return (
    <div className="container-fluid my-5">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h4 className="fw-bold text-tertiary mb-2">
          {officials.length} - Officials Found
        </h4>
        <Link to={`/add-agencyofficial/${plantName}/${renew_id}`} className="btn btn-primary">
          Add Agency Official
        </Link>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered officials-table">
          <thead className="table-light">
            <tr>
              <th>Designation</th>
              <th>Official's Name</th>
              <th>Official's Email</th>
              <th>Phone Number</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {officials.length > 0 ? (
              officials.map((official) => (
                <tr key={official.renew_official_id}>
                  <td>{official.renew_officials_designation}</td>
                  <td>{official.renew_officials_name}</td>
                  <td>{official.renew_officials_email}</td>
                  <td>{official.renew_officials_phone}</td>
                  <td className="text-center">
                    <Link
                      to={`/edit-agencyofficial/${plantName}/${renew_id}/${official.renew_official_id}`}
                      className="btn btn-link text-success me-2 p-0"
                    >
                      <i className="fa fa-edit"></i>
                    </Link>
                    <button
                      className="btn btn-link text-danger p-0"
                      onClick={() => handleDelete(official.renew_official_id)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No officials found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AgencyOfficials;
